import script from "./InfoExtraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoExtraModal.vue?vue&type=script&setup=true&lang=js"

import "./InfoExtraModal.vue?vue&type=style&index=0&id=5cb2212f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb2212f"]])

export default __exports__